/**
 * API Configuration
 * All base URLs and endpoint paths live here.
 * Import these constants instead of hardcoding strings throughout the app.
 */

// export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
export const API_BASE_URL =  'https://uday-api.teamora.uz';

export const ENDPOINTS = {
  auth: {
    login: '/api/v1/auth/sign-in',
    logout: '/api/auth/logout',
    me: '/api/auth/me',
  },
  request: {
    send: '/api/v1/request/send',
    all: '/api/v1/request/all',
    toggleIsRead: (id) => `/api/v1/request/toggleIsRead/${id}`,
  },
  events: {
    all: '/api/v1/events/all',
    add: '/api/v1/events/add',
    update: (id) => `/api/v1/events/update/${id}`,
    delete: (id) => `/api/v1/events/delete/${id}`,
    get: (id) => `/api/v1/events/get/${id}`,
  },
  aboutUs: {
    all: '/api/v1/aboutUs/all',
    add: '/api/v1/aboutUs/add',
    update: (id) => `/api/v1/aboutUs/update/${id}`,
    delete: (id) => `/api/v1/aboutUs/delete/${id}`,
    get: (id) => `/api/v1/aboutUs/get/${id}`,
  },
  medias: {
    upload: '/api/v1/medias/upload-media',
    delete: (id) => `/api/v1/medias/delete-media/${id}`,
  },
  orders: {
    all: '/api/v1/orders/all',
    add: '/api/v1/orders/add',
    update: (id) => `/api/v1/orders/update/${id}`,
    get: (id) => `/api/v1/orders/${id}`,
    toggleStatus: (id) => `/api/v1/orders/toggleStatus/${id}`,
  },
};

export const ROLES = {
  ADMIN: 'ADMIN',
};

export const STORAGE_KEYS = {
  TOKEN: 'auth_token',
  USER: 'auth_user',
};

export const ROUTES = {
  MAIN: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
};

